import { useState } from "react";
import { Map as MapIcon } from "lucide-react";
import { mapThumbUrl, MapViewer } from "@/components/PassageMaps";

export const PostMaps = ({ post }) => {
  const [open, setOpen] = useState(null);
  if (!post.maps?.length) return null;
  return (
    <div className="mt-4" data-testid={`fellowship-post-maps-${post.id}`}>
      <p className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-gold mb-2">
        <MapIcon className="w-3.5 h-3.5" /> Attached maps
      </p>
      <div className="flex flex-wrap gap-3">
        {post.maps.map((m) => (
          <button key={m.id} onClick={() => setOpen(m)} data-testid={`fellowship-post-map-${post.id}-${m.id}`}
            className="group w-40 text-left rounded-xl overflow-hidden border border-border hover:border-gold transition-colors">
            <img src={mapThumbUrl(m.id)} alt={m.title} loading="lazy"
              className="w-full aspect-[4/3] object-cover bg-ink/5 group-hover:scale-[1.03] transition-transform duration-500" />
            <p className="text-xs p-2 text-ink/75 line-clamp-2 bg-card">{m.title}</p>
          </button>
        ))}
      </div>
      <MapViewer map={open} onClose={() => setOpen(null)} />
    </div>
  );
};
